;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('savedReplies', savedReplies)

  function savedReplies () {
    return {
      restrict: 'A',
      controller: 'SavedRepliesController'
    }
  }
})()
